import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useRef, useState, useEffect } from 'react';
import { formatters, loadScript } from '@crehana/utils';
export var getYTembedId = function getYTembedId(url) {
  if (url.includes('embed')) {
    var parts = url.split('/');
    var last = parts.length - 1;
    return parts[last];
  }
  var videoId = formatters.getParameterByName('v', url);
  return videoId || undefined;
};
var YOUTUBE_URL = 'https://www.youtube.com/iframe_api';
function useYouTubePlayer(config) {
  var YTPlayerRef = useRef();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isApiReady = _useState2[0],
    setIsApiReady = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isYTReady = _useState4[0],
    setIsYTReady = _useState4[1];
  useEffect(function () {
    loadScript({
      src: YOUTUBE_URL
    });

    // Ignore window unknown property
    // @ts-ignore
    window.onYouTubeIframeAPIReady = function () {
      setIsApiReady(true);
    };
  }, []);
  useEffect(function () {
    if (isApiReady || window.YT && window.YT.Player) {
      var _ref = config.events || {},
        _onApiChange = _ref.onApiChange,
        _onError = _ref.onError,
        _onPlaybackQualityChange = _ref.onPlaybackQualityChange,
        _onPlaybackRateChange = _ref.onPlaybackRateChange,
        _onReady = _ref.onReady,
        _onStateChange = _ref.onStateChange;
      YTPlayerRef.current = new window.YT.Player(config.tagId || 'YTPlayer', {
        width: '100%',
        height: '100%',
        playerVars: _objectSpread({
          // Set this to support iOS
          playsinline: 1
        }, config.playerVars),
        videoId: config.videoId,
        events: {
          // In case you provide one or more events handlers but it's not required
          onApiChange: function onApiChange(args) {
            if (_onApiChange) {
              _onApiChange(args);
            }
          },
          onError: function onError(args) {
            if (_onError) {
              _onError(args);
            }
          },
          onPlaybackQualityChange: function onPlaybackQualityChange(args) {
            if (_onPlaybackQualityChange) {
              _onPlaybackQualityChange(args);
            }
          },
          onPlaybackRateChange: function onPlaybackRateChange(args) {
            if (_onPlaybackRateChange) {
              _onPlaybackRateChange(args);
            }
          },
          onReady: function onReady(args) {
            setIsYTReady(true);
            if (_onReady) {
              _onReady(args);
            }
          },
          onStateChange: function onStateChange(args) {
            if (_onStateChange) {
              _onStateChange(args);
            }
          }
        }
      });
    }
  }, [config, isApiReady]);
  return {
    YTPlayerRef: YTPlayerRef,
    isReady: isYTReady
  };
}
export default useYouTubePlayer;